import { Button, Container, Text } from "mondrian-react";

import { useBreakpoint } from "hooks/useBreakpoint";
import { View } from "components/View";
import { MceCloseButton } from "components/CloseButton";
import "./styles.scss";
import { useWebPush } from "hooks/useWebpush.hooks";

export const WebPushNotification = () => {
  const { greaterOrEqual } = useBreakpoint();
  const { isOpenAlert, onCloseClickAlert, onRequestPermission } = useWebPush();

  const isDesktop = greaterOrEqual("md");

  if (!isOpenAlert) return;

  return (
    <View className="night-bar-container">
      <Container className="content-notification-bar">
        <View className="flex">
          <Text className="paragraph-webpush" body inverse>
            Quer mais benefícios para sua empresa? Ative as notificações e
            receba nossas ofertas exclusivas!
          </Text>
          {!isDesktop && <MceCloseButton onClick={onCloseClickAlert} />}
        </View>

        <View className="gap-btn--xs">
          <Button onClick={onRequestPermission}>Quero receber ofertas</Button>
          {isDesktop && (
            <Button secondaryInverse onClick={onCloseClickAlert}>
              Agora não
            </Button>
          )}
        </View>
      </Container>
    </View>
  );
};
